// SHEventCard.js
import React, { useContext, useEffect, useState } from 'react';
import './SHEventCard.css';
import { TbEdit, TbTrash, TbTag, TbUsers } from 'react-icons/tb';
import { useLanguage } from '../../../../LanguageProvider';
import EditEventModal from '../EditEventModal/EditEventModal';
import AlertBox from '../../../../components/AlertBox/AlertBox';
import Services from '../../../../services/Services';
import { useToaster } from '../../../../ToasterProvider';
import { GeneralContext } from '../../../../GeneralProvider';

export default function SHEventCard({
    isOnline,
    imageSrc,
    title,
    dateBadge,
    location,
    date,
    onClick,
    website,
    isFree,
    isAdmin,
    event,
    getEvents,
    participants,
}) {
    const token = localStorage.getItem("token")

    const { getTranslation } = useLanguage();
    const { toastWarning, toastSuccess } = useToaster();
    const { setCreateProjectLoading } = useContext(GeneralContext);

    const [editModalOpen, setEditModalOpen] = useState(false);
    const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
    const [participantCount, setParticipantCount] = useState(0);

    const handleCardClick = () => {
        if (!editModalOpen) {
            onClick();
        }
    };

    const handleEditClick = (e) => {
        e.stopPropagation();
        setEditModalOpen(true);
    };

    const handleRemoveClicked = (e) => {
        e.stopPropagation();
        setIsAlertModalOpen(true)
    }

    const handleConfirmDeleteEvent = () => {
        Services.SocialHiveRemoveEvent(token, event.eventID)
            .then((res) => {
                setCreateProjectLoading(false)
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"));
                    getEvents();
                } else {
                    toastWarning(getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastWarning(getTranslation("somethingWentWrong"));
            });
    }

    useEffect(() => {
        const getSoldTicketListCount = () => {
            Services.SocialHiveGetEventSoldTickets(token, event.eventID)
                .then((res) => {
                    setParticipantCount(res?.data?.result.length)
                })
                .catch((err) => {
                    console.error(err);
                });

        };

        getSoldTicketListCount()
    }, [event, token]);

    return (
        <>
            <div className="sh-event-card" style={{ position: 'relative' }} onClick={handleCardClick}>
                {isAdmin === "1" && (
                    <>
                        <span
                            style={{ position: 'absolute', top: 10, right: 35, zIndex: 99, width: '20px', height: '20px', backgroundColor: 'var(--sh-settings-tabs-selected-border)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={handleEditClick}
                        >
                            <TbEdit color='var(--sh-settings-title-color)' className="sh-icon" />
                        </span>
                        <span
                            style={{ position: 'absolute', top: 10, right: 10, zIndex: 99, width: '20px', height: '20px', backgroundColor: 'var(--sh-chat-status-error-color)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            onClick={handleRemoveClicked}
                        >
                            <TbTrash color='var(--sh-settings-title-color)' className="sh-icon" />
                        </span>
                    </>

                )}

                <div className="sh-image-wrapper" style={{ width: '250px' }}>
                    <img
                        src={imageSrc}
                        alt={title}
                        height={150}
                        className="sh-card-image"
                    />
                    {/* <span className="sh-event-card-date-badge">{dateBadge}</span> */}
                </div>

                <div className="sh-card-content">
                    {/* Date above title */}
                    <div className="sh-right-date">
                        <span>{date}</span>
                    </div>

                    {/* Title */}
                    <span className="sh-event-title">{title}</span>

                    {/* Location under title */}
                    {isOnline === "1" ? (
                        <div className="sh-location" style={{ marginBottom: 0, fontSize: '14px' }}>
                            <span>{website}</span>
                        </div>
                    ) : (
                        <div className="sh-location" style={{ marginBottom: 0, fontSize: '14px' }}>
                            <span>{location}</span>
                        </div>
                    )}

                    {/* Badges row: attendee count + event type */}
                    <div className="sh-right-badges">
                        {event?.settings?.showParticipantCount && (
                            <div className="sh-badge sh-badge-attendees">
                                <TbUsers className="sh-icon" />
                                <span>{participantCount} {getTranslation("peopleAttending")}</span>
                            </div>
                        )}

                        <div className="sh-badge">
                            <TbTag className="sh-icon" />
                            {(isFree === "0" || isFree === "1" || event.hasTickets !== "1") && <span>{getTranslation("free")}</span>}
                            {(isFree === "2" && event.hasTickets === "1") && <span>{getTranslation("paid")}</span>}
                            {(isFree === "3" && event.hasTickets === "1") && <span>{getTranslation("freePaid")}</span>}
                        </div>
                    </div>
                </div>


            </div>

            {editModalOpen &&

                <EditEventModal
                    isOpen={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    event={event}
                    getEvents={getEvents}
                />
            }

            <AlertBox
                isOpen={isAlertModalOpen}
                title={getTranslation("areYouSure")}
                message={getTranslation("deleteEventConfirm")}
                onConfirm={handleConfirmDeleteEvent}
                onCancel={() => setIsAlertModalOpen(false)}
                confirmText={getTranslation("yes")}
                cancelText={getTranslation("no")}
                type={"warning"}
            />
        </>

    );
}
